import {getHttp, postHttp} from '@/utils/vueresource.js'
// import axios from 'axios'
function getList (url, params, request) { // 传入地址和参数
    return new Promise(resolve => {
        if (!request) {
            getHttp(url, params).then(res => {
                console.log('数据返回res--------->', res.data)
                let data = {}
                try {
                    res.data.data.records.forEach(item => {
                        if (item.travelValue) {
                            item.travelValue = JSON.parse(item.travelValue)
                            item.travelValue.title = item.title
                        }
                        data[item.travelKey] = item.travelValue
                    })
                    console.log('data----->', data)
                    resolve(data)
                } catch (error) {
                    resolve(res.data)
                    console.warn('解析失败', error)
                }
            })
        } else if (request.toUpperCase() === 'POST') {
            postHttp(url, params).then(res => {
                resolve(res.data)
            })
        }
    })
}
// 省外详情
function getSourceList (url, params) { // 传入地址和参数
    return new Promise(resolve => {
    // return get(url, params)
        getHttp(url, params).then(res => {
            console.log('data----->', res.data.data)
            let data
            switch (params.travelKey) {
                // 游客排行榜
                case 'touristRanking':
                    data = res.data.data ? JSON.parse(res.data.data).list : []
                    break
                // 车辆排行榜
                case 'carRanking':
                    data = res.data.data !== '暂无承载数据' ? JSON.parse(res.data.data).list : []
                    break
                // 出现态势感知
                case 'situationalAwareness':
                    data = res.data.data ? JSON.parse(res.data.data).tableList : {}
                    break
                // 增长率
                case 'growthRate':
                    data = res.data.data ? JSON.parse(res.data.data) : {}
                    break
                // 地区数据
                case 'totalNumber':
                    data = res.data.data ? JSON.parse(res.data.data).list : []
                    break
            }
            resolve(data)
        })
    })
}

// 省内详情页面
function getCitySourceList (url, params) { // 传入地址和参数
    return new Promise(resolve => {
        getHttp(url, params).then(res => {
            console.log('data----->', res.data.data)
            let data
            switch (params.travelKey) {
                // 右上角数据
                case 'todayData':
                    data = res.data.data ? JSON.parse(res.data.data).orderList : []
                    break
                // 内容云图片
                case 'contentCloud':
                    data = res.data.data ? JSON.parse(res.data.data).det : []
                    break
                // 城市列表
                case 'cityList':
                    data = res.data.data ? JSON.parse(res.data.data).cityList : []
                    break
                // 地图标点
                case 'centerMap':
                    data = res.data.data ? JSON.parse(res.data.data).coordinateAry : []
                    break
                // 地图资源
                case 'dataBelowMap':
                    data = res.data.data ? JSON.parse(res.data.data).resourceList : []
                    break
                // 内容云统计
                case 'contentQuantity':
                    data = res.data.data ? JSON.parse(res.data.data).contentList : []
                    break
                // 七日客流趋势
                case 'passengerFlowData':
                    data = res.data.data ? JSON.parse(res.data.data).trend : []
                    break
            }
            resolve(data)
        })
    })
}
// 公路
function getHighwayList (url, params) { // 传入地址和参数
    return new Promise(resolve => {
        getHttp(url, params).then(res => {
            console.log('data----->', res.data.data)
            let data
            switch (params.travelKey) {
                // 右上角数据
                case 'totalNumber':
                    data = res.data.data ? JSON.parse(res.data.data).list : []
                    break
                case 'touristList':
                    data = res.data.data ? JSON.parse(res.data.data).list : []
                    break
                case 'tollStationList':
                    data = res.data.data ? JSON.parse(res.data.data).sfzObj : []
                    break
            }
            resolve(data)
        })
    })
}
// 铁路
function getRailwayList (url, params) { // 传入地址和参数
    return new Promise(resolve => {
        getHttp(url, params).then(res => {
            console.log('data----->', res.data.data)
            let data
            switch (params.travelKey) {
                // 右上角数据
                case 'totalNumber':
                    data = res.data.data ? JSON.parse(res.data.data).list : []
                    break
                case 'touristList':
                    data = res.data.data ? JSON.parse(res.data.data).list : []
                    break
                case 'stationList':
                    data = res.data.data ? JSON.parse(res.data.data).czObj : []
                    break
                case 'topTag':
                    data = res.data.data ? JSON.parse(res.data.data).list : []
                    break
            }
            resolve(data)
        })
    })
}
// 民航
function getFlightList (url, params) { // 传入地址和参数
    return new Promise(resolve => {
        getHttp(url, params).then(res => {
            console.log('data----->', res.data.data)
            let data
            switch (params.travelKey) {
                // 右上角数据
                case 'totalNumber':
                    data = res.data.data ? JSON.parse(res.data.data).list : []
                    break
                case 'touristList':
                    data = res.data.data ? JSON.parse(res.data.data).list : []
                    break
                case 'airportList':
                    data = res.data.data ? JSON.parse(res.data.data).jcObj : []
                    break
            }
            resolve(data)
        })
    })
}

// 景区详情
function getScenicList (url, params) { // 传入地址和参数
    return new Promise(resolve => {
        getHttp(url, params).then(res => {
            let data
            switch (params.travelKey) {
                // 右上角数据
                case 'allData':
                    data = res.data.data ? JSON.parse(res.data.data) : []
                    break
                case 'rightData':
                    data = res.data.data ? JSON.parse(res.data.data) : []
                    break
                case 'scenicOrderNum':
                    data = res.data.data ? JSON.parse(res.data.data) : []
                    break
            }
            resolve(data)
        })
    })
}

export default { // 输出
    getList,
    getSourceList,
    getCitySourceList,
    getHighwayList,
    getRailwayList,
    getFlightList,
    getScenicList
}



// WEBPACK FOOTER //
// ./src/utils/common.js